import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import Layout from "../core/components/Layout/Layout";
import ListRemoval from "../page/ListRemoval/ListRemoval";
import "./custom.css";
import {
  changeCountry,
  changeLanguage,
} from "../redux/Slices/LangSettingsSlice";
import { changeCountryCode } from "../redux/Slices/PostMailSlice";
import { glassboxErrorEvent } from "../core/components/Glassbox/Glassbox";

const App = () => {
  const { search } = useLocation();
  const sp = new URLSearchParams(search);
  const dispatch = useDispatch();

  window.addEventListener("error", (event) => {
    glassboxErrorEvent(event);
  });

  const country = sp.get("c");
  const lang = sp.get("l");

  // Set lang attribute dynamically for accessibility (WCAG 3.1.1)
  useEffect(() => {
    const langCode = sp.get("l") || "en";
    document.documentElement.lang = langCode;
  }, [sp]);

  if (
    country &&
    country.trim().length === 2 &&
    lang &&
    lang.trim().length === 2
  ) {
    dispatch(changeCountry(country));
    dispatch(changeCountryCode(country.toUpperCase()));
    dispatch(changeLanguage(lang));
  }

  return (
    <Layout>
      <ListRemoval />
    </Layout>
  );
};

export default App;
